import React, { useEffect } from 'react'
import Icon, { IconProps } from '@ui/elements/Icon'
import Animated, {
  AnimatedProps,
  Easing,
  FadeIn,
  FadeOut,
  cancelAnimation,
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withTiming,
} from 'react-native-reanimated'
import { ViewProps } from 'react-native'

interface Props extends AnimatedProps<ViewProps> {
  loading: boolean
  iconProps?: Partial<IconProps>
  hidden?: boolean
  animate?: boolean
}

export default function Loader({
  loading,
  iconProps,
  animate = true,
  hidden = true,
  ...props
}: Props) {
  const rotation = useSharedValue<number>(0)

  const loaderStyle = useAnimatedStyle(() => ({
    transform: [{ rotate: `${rotation.value}deg` }],
  }))

  const startAnimation = () => {
    rotation.set(
      withRepeat(
        withTiming(360, {
          duration: 1000,
          easing: Easing.linear,
        }),
        -1,
        false
      )
    )
  }

  useEffect(() => {
    if (loading) {
      startAnimation()
      return
    }
    if (!loading) {
      rotation.value = 0
      return
    }
    return () => cancelAnimation(rotation)
  }, [loading])

  if (hidden && !loading) return null

  return (
    <Animated.View
      style={[loaderStyle]}
      entering={animate ? FadeIn.duration(1000) : undefined}
      exiting={animate ? FadeOut.duration(250) : undefined}
      {...props}
    >
      <Icon {...iconProps} name="loader-2" />
    </Animated.View>
  )
}
